import * as React from 'react';

function TableTennis(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.43 9.814l9.755 9.755a8.788 8.788 0 01-4.388-.62L7.24 21.51a1.68 1.68 0 01-2.375 0l-2.373-2.375a1.679 1.679 0 010-2.374l2.557-2.558a8.785 8.785 0 01-.62-4.388zm13.373 3.936a2.518 2.518 0 110 5.036 2.518 2.518 0 010-5.036zM13.187 2A8.812 8.812 0 0122 10.813c0 1.15-.22 2.25-.621 3.256l-.072-.111a4.196 4.196 0 00-7.685 2.675l-8.75-8.751A8.817 8.817 0 0113.188 2z"
        fill="currentColor"
      />
    </svg>
  );
}

export default TableTennis;
